import { NgModule, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

// components
import { TooltipComponent } from './tooltip/tooltip.component';
import { PolicyDetailsComponent } from './policy-details/policy-details.component';
import { PolicyDetailsNyComponent } from './policy-details-ny/policy-details-ny.component';
import { PolicyDetailsCirComponent } from './policy-details-cir/policy-details-cir.component';
import { LoadingModule } from './loading/loading.module';
import { SpinnerModule } from './spinner/spinner.module';
import { ToasterComponent } from '../overlays/toaster/toaster.component';
import { IconComponent } from './icons/icon.component';
import { BasicDropdownComponent } from './basic-dropdown/basic-dropdown.component';
import { SmallTooltipComponent } from './small-tooltip/small-tooltip.component';
import { InformationCardComponent } from './information-card/information-card.component';
import { ControlMessagesComponent } from './control-message/control-messages.component';
import { ProgressIndicatorComponent } from './progress-indicator/progress-indicator.component';
import { BasicTooltipComponent } from './basic-tooltip/basic-tooltip.component';
import { GenesysConstellationComponent } from './genesys-constellation/genesys-constellation.component';

// pipes
import { CasCurrencyPipe } from '../../classes/CasCurrencyPipe';
import { IsXAxisOverflowPipe } from '../../classes/isXAxisOverflowPipe';
import { AsFormControlPipe } from '../../classes/as-form-control.pipe';
import { AsFormGroupPipe } from '../../classes/as-form-group.pipe';

// directives
import { DebounceClickEventDirective } from './directives/debounceClickEvent.directive';

// modules

// services

@NgModule({
  declarations: [
    TooltipComponent,
    SmallTooltipComponent,
    BasicTooltipComponent,
    PolicyDetailsComponent,
    PolicyDetailsNyComponent,
    PolicyDetailsCirComponent,
    ToasterComponent,
    IconComponent,
    BasicDropdownComponent,
    InformationCardComponent,
    ControlMessagesComponent,
    ProgressIndicatorComponent,
    GenesysConstellationComponent,
    DebounceClickEventDirective,
    CasCurrencyPipe,
    IsXAxisOverflowPipe,
    AsFormControlPipe,
    AsFormGroupPipe,
  ],
  imports: [CommonModule, RouterModule, ReactiveFormsModule, LoadingModule, SpinnerModule],
  exports: [
    TooltipComponent,
    SmallTooltipComponent,
    BasicTooltipComponent,
    PolicyDetailsComponent,
    PolicyDetailsNyComponent,
    PolicyDetailsCirComponent,
    ToasterComponent,
    IconComponent,
    BasicDropdownComponent,
    InformationCardComponent,
    ControlMessagesComponent,
    ProgressIndicatorComponent,
    GenesysConstellationComponent,
    DebounceClickEventDirective,
    CasCurrencyPipe,
    IsXAxisOverflowPipe,
    AsFormControlPipe,
    AsFormGroupPipe,
  ],
  providers: [],
  bootstrap: [],
})
export class SharedModule {}
